<template><section><h2>form</h2>
<demo-block>
                  <div slot="source"><template>
  <weui-form :title="'验证码'" :desc="'验证手机号样式'">
    <weui-form-control>
      <weui-form-group :tips="'收不到验证码'">
        <weui-input v-model="mobile" placeholder="请输入手机号" label="手机号" type="number" pattern="[0-9]*" right-slot :maxlength="11">
          <weui-button :type="'text'">
            <weui-icon :type="'info-circle'" :mini="true"></weui-icon>
          </weui-button>
        </weui-input>
        <weui-input v-model="code" placeholder="请输入验证码" label="验证码" type="number" pattern="[0-9]*" right-slot :maxlength="6">
          <weui-button :type="'default'" :in-form="true">获取验证码</weui-button>
        </weui-input>
      </weui-form-group>
    </weui-form-control>
    <weui-form-tip>
      <template #content>
        <weui-checkbox-agree v-model="agree" :animate.sync="agreeAnimate">
          阅读并同意
          <a href="javascript:">《相关条款》</a>
        </weui-checkbox-agree>
      </template>
    </weui-form-tip>
    <weui-form-opr>
      <weui-button :disabled="code.length == 0" @click="save()">确定</weui-button>
    </weui-form-opr>
  </weui-form>
</template>

</div>
                  
                  <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;weui-form :title=&quot;'验证码'&quot; :desc=&quot;'验证手机号样式'&quot; &gt;
    &lt;weui-form-control&gt;
      &lt;weui-form-group :tips=&quot;'收不到验证码'&quot;&gt;
        &lt;weui-input v-model=&quot;mobile&quot; placeholder=&quot;请输入手机号&quot; label=&quot;手机号&quot; type=&quot;number&quot; pattern=&quot;[0-9]*&quot; right-slot :maxlength=&quot;11&quot;&gt;
          &lt;weui-button :type=&quot;'text'&quot;&gt;
            &lt;weui-icon :type=&quot;'info-circle'&quot; :mini=&quot;true&quot;&gt;&lt;/weui-icon&gt;
          &lt;/weui-button&gt;
        &lt;/weui-input&gt;
        &lt;weui-input v-model=&quot;code&quot; placeholder=&quot;请输入验证码&quot; label=&quot;验证码&quot; type=&quot;number&quot; pattern=&quot;[0-9]*&quot; right-slot :maxlength=&quot;6&quot;&gt;
          &lt;weui-button :type=&quot;'default'&quot; :in-form=&quot;true&quot;&gt;获取验证码&lt;/weui-button&gt;
        &lt;/weui-input&gt;
      &lt;/weui-form-group&gt;
    &lt;/weui-form-control&gt;
    &lt;weui-form-tip&gt;
      &lt;template #content&gt;
        &lt;weui-checkbox-agree v-model=&quot;agree&quot; :animate.sync=&quot;agreeAnimate&quot;&gt;
          阅读并同意
          &lt;a href=&quot;javascript:&quot;&gt;《相关条款》&lt;/a&gt;
        &lt;/weui-checkbox-agree&gt;
      &lt;/template&gt;
    &lt;/weui-form-tip&gt;
    &lt;weui-form-opr&gt;
      &lt;weui-button :disabled=&quot;code.length == 0&quot; @click=&quot;save()&quot;&gt;确定&lt;/weui-button&gt;
    &lt;/weui-form-opr&gt;
  &lt;/weui-form&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        mobile: '',
        code: '',
        agree: false,
        agreeAnimate: false
      }
    },
    methods: {
      save: function() {
        console.log(this.agreeAnimate)
        if(!this.agree) {
          this.agreeAnimate = true
        }
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2>Attributes</h2>
<h3>form</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>标题</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>desc</td>
<td>描述</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>form-group</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>标题</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>input</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>label</td>
<td>标签</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>value(v-model)</td>
<td>输入框内容</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>type</td>
<td>类型</td>
<td>string</td>
<td>同input标签</td>
<td>—</td>
</tr>
<tr>
<td>placeholder</td>
<td>输入框为空时占位符</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>readonly</td>
<td>只读</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>autofocus</td>
<td>自动聚焦</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>maxlength</td>
<td>最大输入长度，设置为 -1 的时候不限制最大长度</td>
<td>number</td>
<td>—</td>
<td>-1</td>
</tr>
<tr>
<td>pattern</td>
<td>输入内容的正则表达式</td>
<td>number</td>
<td>—</td>
<td>-1</td>
</tr>
<tr>
<td>error(sync)</td>
<td>错误状态</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3>checkbox-agree</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value(v-model)</td>
<td>是否选择</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>animate(sync)</td>
<td>提醒动画</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
</tbody>
</table>
</section></template>

<script>
  export default {
    data() {
      return {
        mobile: '',
        code: '',
        agree: false,
        agreeAnimate: false
      }
    },
    methods: {
      save: function() {
        console.log(this.agreeAnimate)
        if(!this.agree) {
          this.agreeAnimate = true
        }
      }
    }
  }
</script>